import MapboxMap from './mapbox_map'
import MapboxDraw from '@mapbox/mapbox-gl-draw'

// This custom Mapbox Draw Mode stops the use from interacting with drawn shapes, ie stops them being deleted, moved or resized
// Copied from this old unmaintaned package: https://github.com/mapbox/mapbox-gl-draw-static-mode
// Given how little code there is I didn't think it work adding the package
// More about custom modes here: https://github.com/mapbox/mapbox-gl-draw/blob/main/docs/MODES.md
const StaticMode = {
  onSetup: function () {
    this.setActionableState() // default actionable state is false for all actions
    return {}
  },
  toDisplayFeatures: function (state, geojson, display) {
    display(geojson)
  }
}

export default {
  ...MapboxMap,
  mountedCallback() {
    this.draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {},
      modes: {
        ...MapboxDraw.modes,
        // override default built in "simple_select" mode so that we don't have to setup custom styles for the custom "static" mode.
        simple_select: StaticMode
      },
      userProperties: true,
      styles: [
        ...MapboxDraw.lib.theme,
        {
          id: 'hover-selected-fill',
          type: 'fill',
          filter: ['all', ['==', 'user_debug', 'hover-selected']],
          paint: {
            'fill-color': '#fcb933',
            'fill-opacity': 0.4
          }
        },
        {
          id: 'hover-selected-outline',
          type: 'line',
          filter: ['all', ['==', 'user_debug', 'hover-selected']],
          paint: {
            'line-color': '#fcb933',
            'line-opacity': 1
          }
        },
        {
          id: 'debug-selected-fill',
          type: 'fill',
          filter: ['all', ['==', 'user_debug', 'selected']],
          paint: {
            'fill-color': '#00ff00',
            'fill-opacity': 0.25
          }
        },
        {
          id: 'debug-selected-outline',
          type: 'line',
          filter: ['all', ['==', 'user_debug', 'selected']],
          paint: {
            'line-color': '#00ff00',
            'line-opacity': 1
          }
        },
        {
          id: 'debug-sara-fill',
          type: 'fill',
          filter: ['all', ['==', 'user_debug', 'sara']],
          paint: {
            'fill-color': '#ffff00',
            'fill-opacity': 0.25
          }
        },
        {
          id: 'debug-sara-outline',
          type: 'line',
          filter: ['all', ['==', 'user_debug', 'sara']],
          paint: {
            'line-color': '#ffff00',
            'line-width': 10
          }
        },
        {
          id: 'debug-sara-circle',
          type: 'circle',
          filter: ['all', ['==', 'user_debug', 'sara']],
          paint: {
            'circle-color': '#ffff00',
            'circle-radius': 10
          }
        },
        {
          id: 'debug-sara-selected-fill',
          type: 'fill',
          filter: ['all', ['==', 'user_debug', 'sara-selected']],
          paint: {
            'fill-color': '#ff00ff',
            'fill-opacity': 0.25
          }
        },
        {
          id: 'debug-sara-selected-outline',
          type: 'line',
          filter: ['all', ['==', 'user_debug', 'sara-selected']],
          paint: {
            'line-color': '#ff00ff',
            'line-width': 10
          }
        },
        {
          id: 'debug-sara-selected-circle',
          type: 'circle',
          filter: ['all', ['==', 'user_debug', 'sara-selected']],
          paint: {
            'circle-color': '#ff00ff',
            'circle-radius': 10
          }
        },
        {
          id: 'debug-sara-point-circle',
          type: 'circle',
          filter: ['all', ['==', 'user_debug', 'sara-point']],
          paint: {
            'circle-color': '#42f5ef',
            'circle-radius': 10
          }
        },
        {
          id: 'debug-adjacent-fill',
          type: 'fill',
          filter: ['all', ['==', 'user_debug', 'adjacent']],
          paint: {
            'fill-color': '#ff00ff',
            'fill-opacity': 0.15
          }
        },
        {
          id: 'debug-adjacent-outline',
          type: 'line',
          filter: ['all', ['==', 'user_debug', 'adjacent']],
          paint: {
            'line-color': '#ff00ff',
            'line-opacity': 1
          }
        },
        {
          id: 'debug-within-2km-fill',
          type: 'fill',
          filter: ['all', ['==', 'user_debug', 'within-2km']],
          paint: {
            'fill-color': '#ffffff',
            'fill-opacity': 0
          }
        },
        {
          id: 'debug-within-2km-outline',
          type: 'line',
          filter: ['all', ['==', 'user_debug', 'within-2km']],
          paint: {
            'line-color': '#ffff00',
            'line-opacity': 1
          }
        },
        {
          id: 'debug-huc12-fill',
          type: 'fill',
          filter: ['all', ['==', 'user_debug', 'huc12']],
          paint: {
            'fill-color': '#000000',
            'fill-opacity': 0.1
          }
        },
        {
          id: 'debug-huc12-outline',
          type: 'line',
          filter: ['all', ['==', 'user_debug', 'huc12']],
          paint: {
            'line-color': '#ffffff',
            'line-opacity': 0.7
          }
        },
        {
          id: 'debug-treatment-fill',
          type: 'fill',
          filter: ['all', ['==', 'user_debug', 'treatment']],
          paint: {
            'fill-color': '#000000',
            'fill-opacity': 0.0
          }
        },
        {
          id: 'debug-treatment-outline',
          type: 'line',
          filter: ['all', ['==', 'user_debug', 'treatment']],
          paint: {
            'line-color': '#ff00ff',
            'line-opacity': 0.7,
            'line-width': 4
          }
        }
      ]
    })

    this.map.addControl(this.draw, 'top-left')

    const createArea = (e) => {
      this.sendEvent('map.draw.create', {
        feature_ref: e.features[0].id,
        coordinates: e.features[0].geometry.coordinates
      })
    }
    this.map.on('draw.create', createArea)

    this.handleTargetedEvent('set-map-mode', ({ new_mode }) => {
      this.draw.changeMode(new_mode)
    })

    this.handleTargetedEvent('add-landscape-boundary', ({ name, layer }) => {
      this.map.addLayer(layer)
    })

    this.handleTargetedEvent('remove-layer', ({ name, id }) => {
      if (this.map.getLayer(id)) {
        this.map.removeLayer(id)
        this.map.removeSource(id)
      }
    })

    this.handleTargetedEvent(
      'refresh-landscape-boundary',
      ({ name, layer }) => {
        if (this.map.getLayer(layer.id)) {
          this.map.removeLayer(layer.id)
          this.map.removeSource(layer.id)
        }
        this.map.addLayer(layer)
      }
    )

    // if the feature_ref already exists `draw.add` will replace it with the one passed in
    const setFeature = ({ feature_ref, geometry, properties }) => {
      if (feature_ref && geometry) {
        this.draw.add({
          id: feature_ref,
          type: 'Feature',
          geometry: geometry,
          properties: properties
        })
      }
    }

    this.handleTargetedEvent('add-feature', setFeature)
    this.handleTargetedEvent('replace-feature', setFeature)

    this.handleTargetedEvent('delete-feature', ({ feature_ref }) => {
      this.draw.delete(feature_ref)
    })
  }
}
